import React, { memo, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Button, Space, Tooltip, Typography } from 'antd'

import { GridFormItem } from '../../../core/components/sections'
import { useQueryParams } from '../../../core/hooks'

import { PAGINATION } from '../../../common/constants'

import { useLoggedInUser } from '../../../account/hooks'

import UnknownWordsModal from './unknown-words-modal'

const UnknownWordsButtons = () => {
  const { settings: userSettings } = useLoggedInUser()
  const { isUnknownWordsModalShown, setQueryParams } = useQueryParams()

  const { data: menuCurationTask } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const {
    id: menuCurationTaskId,
    curatedUnknownWordCount,
    qadUnknownWordCount,
    totalUnknownWordCount,
  } = menuCurationTask

  const isModalDisabled = useMemo(
    () => !totalUnknownWordCount,
    [totalUnknownWordCount],
  )

  const openModal = useCallback(
    () =>
      setQueryParams({
        isUnknownWordsModalShown: true,
        unknownWordsCurrentPage: PAGINATION.DEFAULT_PAGE,
        unknownWordsPageSize:
          userSettings?.pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
      }),
    [setQueryParams, userSettings?.pageSize],
  )

  return (
    <GridFormItem
      span={8}
      label={
        <Typography.Text>
          Unknown Words{' '}
          <Space>
            <Tooltip title="Curated words">
              (
              <Typography.Text>
                {curatedUnknownWordCount} / {totalUnknownWordCount}
              </Typography.Text>
              )
            </Tooltip>
            <Tooltip title="Qad words">
              (
              <Typography.Text>
                {qadUnknownWordCount} / {totalUnknownWordCount}
              </Typography.Text>
              )
            </Tooltip>
          </Space>
        </Typography.Text>
      }
    >
      <Space>
        <Button disabled={isModalDisabled} onClick={openModal}>
          Open U.W. Modal
        </Button>
      </Space>

      {isUnknownWordsModalShown && (
        <UnknownWordsModal menuCurationTaskId={menuCurationTaskId} />
      )}
    </GridFormItem>
  )
}

export default memo(UnknownWordsButtons)
